<div class="flex flex-col w-full h-full p-6 gap-6 bg-white overflow-auto">

  <create-ta-timeline></create-ta-timeline>

  <create-ta-title-bar [stepTitle]="store.currentCreateTaStep().subtitle ?? store.currentCreateTaStep().title"></create-ta-title-bar>

  <create-ta-step-container [currentStep]="store.currentCreateTaStep()"></create-ta-step-container>

</div>


<!-- The air travel caveat doesn't apply to a flight-only TA. -->
<p-dialog [visible]="taInfoModalVisible && !taSubmissionDatasource.isFlightOnly()" (visibleChange)="taInfoModalVisible = $event">
  <ng-template #headless>
    <div class="flex flex-col px-8 py-8 gap-4 rounded-xl bg-blue-100 w-[600px] text-surface-700 text-sm font-normal font-['Inter'] leading-5">
      <div class="flex w-full justify-center text-surface-900 text-lg font-semibold font-['Inter'] leading-5">Important Information about your TA</div>

      <div class="text-surface-700 text-sm font-normal font-['Inter'] leading-5">
          Although this system asks you to provide information about most aspects of your travel plans, it is important to note that your TA <b>does not</b> provide any reimbursement for the following:
      </div>

      <div class="px-4">
        <dl>
          <li class="text-surface-700 text-sm font-normal font-['Inter'] leading-5">Air travel costs</li>
          <li class="text-surface-700 text-sm font-normal font-['Inter'] leading-5">Hire car costs</li>
          <li class="text-surface-700 text-sm font-normal font-['Inter'] leading-5">Accommodation in cities or towns</li>
        </dl>
      </div>

      <div class="text-surface-700 text-sm font-normal font-['Inter'] leading-5">
        These items must be booked via Corporate Travel Management (CTM) and CLC will pay CTM direct.
      </div>

      <div class="flex items-center gap-2">
        <p-check-box size="small" [(ngModel)]="taInfoModalDontShowSetting" [binary]="true"></p-check-box>
        <span>I understand - don’t show me this again.</span>
      </div>
      <div class="flex w-full bg-white rounded-lg">
        <p-button
          label="Close"
          class="flex-1"
          severity="secondary"
          styleClass="w-full"
          size="small"
          [outlined]="true"
          (click)="closeDialog()"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
